// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","CategoriesList":"bj_a bhg_ea bhg_kb bhg_js bhg_wj"};